"use strict";

export default {
  default: {},
  validator() {},
};
